// extracted by mini-css-extract-plugin
export var lg = "_ig-4";
export var md = "_ig-3";
export var reactTimePickerInputGroupAmPm = "_ig-6";
export var redoTimePicker = "_ig-0";
export var sm = "_ig-2";
export var xl = "_ig-5";
export var xs = "_ig-1";